export class ApplicationAccessWorkflow {
    taskId: string;
    accountOrganisationApplicationClaimId: string;
    accountOrganisationId: string;
    userId: string;
    statusCode: string;
    comment: string;
    applicationClaimId: string;
}




// WEBPACK FOOTER //
// ./src/app/models/applicationAccessWorkflow.ts